import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";

const ConfirmStoreChange = ({
  confirmStoreChangeModalVisible,
  setConfirmStoreChangeModalVisible,
  sendDataToConfirmStoreChange,
}) => {
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const handleConfirmation = () => {
    setIsSubmitButtonPressed(true);
    sendDataToConfirmStoreChange({
      success: true,
    });
    setIsSubmitButtonPressed(false);
    setConfirmStoreChangeModalVisible(false);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    sendDataToConfirmStoreChange({
      success: false,
    });
    setConfirmStoreChangeModalVisible(!confirmStoreChangeModalVisible);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={confirmStoreChangeModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!confirmStoreChangeModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column  "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Change Store
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="flex-auto mt-1 mx-4">
              <p
                className=" text-center font-semibold text-2xl block"
                style={{ color: "red" }}
              >
                Please Confirm Do You Want Change
              </p>
            </div>

            <div className="flex-auto  mx-4">
              <p
                className=" text-center font-semibold text-xl block"
                style={{ color: "red" }}
              >
                If store change then selected data will be removed
              </p>
            </div>

            <div className="flex flex-1 mt-2">
              <Button
                onClick={handleConfirmation}
                disabled={isSubmitButtonPressed}
                className="flex-1 mt-1 mb-3 mx-4 p-1 border-round-xl "
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Yes
                </p>
              </Button>
              <Button
                onClick={() => {
                  setIsSubmitButtonPressed(false);
                  sendDataToConfirmStoreChange({
                    success: false,
                  });
                  setConfirmStoreChangeModalVisible(
                    !confirmStoreChangeModalVisible
                  );
                }}
                disabled={isSubmitButtonPressed}
                className="flex-1 mt-1 mb-3 mx-4 p-1 border-round-xl "
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  No
                </p>
              </Button>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default ConfirmStoreChange;
